<template>
	<header class="custom-nav" role="banner">
		<div class="custom-nav__inner">
			<button
				type="button"
				class="custom-nav__back"
				aria-label="返回"
				@click="$emit('back')"
			>
				<!-- <svg class="custom-nav__chevron" viewBox="0 0 24 24" aria-hidden="true">
					<path
						fill="currentColor"
						d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
					/>
				</svg> -->
				<img class="custom-nav__chevron" src="../../public/img/jt1.png" alt="">
			</button>
			<h1 class="custom-nav__title">{{ title }}</h1>
			<!-- 与左侧返回同宽，标题 flex 居中不偏、也少碰刘海区 -->
			<div class="custom-nav__spacer" aria-hidden="true"></div>
		</div>
	</header>
</template>

<script>
	export default {
		name: 'CustomNavBar',
		props: {
			title: {
				type: String,
				default: '一瓶一码'
			},
			badgeText: {
				type: String,
				default: '100'
			},
			showBadge: {
				type: Boolean,
				default: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.custom-nav {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		/* WebView 内 iframe/视频层可能压住较低 z-index，抬高保证导航可见 */
		z-index: 10000;
		background-color: #000000;
		box-sizing: border-box;
		/* --app-safe-area-top 由 main.js / safeArea.js 探测并写入（WebView 内 env 常为 0 时也能保底） */
		padding-top: constant(safe-area-inset-top);
		padding-top: env(safe-area-inset-top, 0px);
		padding-top: var(--app-safe-area-top, env(safe-area-inset-top, 0px));
		padding-left: constant(safe-area-inset-left);
		padding-left: env(safe-area-inset-left, 0px);
		padding-right: constant(safe-area-inset-right);
		padding-right: env(safe-area-inset-right, 0px);
	}

	/* 高度必须与 .app-root 的 --app-nav-inner-h 一致，否则会多出一条空白缝 */
	.custom-nav__inner {
		height: var(--app-nav-inner-h, 48px);
		min-height: var(--app-nav-inner-h, 48px);
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 3.2vw;
		box-sizing: border-box;
		position: relative;
	}

	.custom-nav__back {
		flex: 0 0 auto;
		width: 11vw;
		min-width: 36px;
		height: 100%;
		padding: 0;
		margin: 0;
		border: none;
		background: transparent;
		color: #ead0a8;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}

	.custom-nav__chevron {
		width: 6.5vw;
		height: 6.5vw;
		min-width: 22px;
		min-height: 22px;
		max-width: 28px;
		max-height: 28px;
		display: block;
	}

	.custom-nav__title {
		flex: 1;
		min-width: 0;
		margin: 0;
		padding: 0 2vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-family: 'Noto Sans SC', 'PingFang SC', -apple-system, BlinkMacSystemFont, sans-serif;
		font-weight: 500;
		font-size: 4.27vw;
		color: #ead0a8;
		text-align: center;
		line-height: 1.2;
		font-style: normal;
	}

	.custom-nav__spacer {
		flex: 0 0 auto;
		width: 11vw;
		min-width: 36px;
		height: 1px;
		pointer-events: none;
	}

	.custom-nav__right {
		flex: 0 0 auto;
		width: 11vw;
		min-width: 36px;
		display: flex;
		align-items: flex-start;
		justify-content: flex-end;
		padding-top: 0.8vw;
		box-sizing: border-box;
	}

	.custom-nav__badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 7.5vw;
		height: 4.8vw;
		min-height: 18px;
		padding: 0 2.4vw;
		border-radius: 999px;
		background-color: #4cd964;
		color: #ffffff;
		font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, sans-serif;
		font-size: 2.67vw;
		font-weight: 600;
		line-height: 1;
		box-sizing: border-box;
	}
</style>
